import { chain, trim, startsWith } from "lodash"

export function isAliasErrorMessage(errorMessage) {
  return startsWith(errorMessage, 'Variable "$alias" got invalid value')
}

export function getAliasErrorMessage(errorMessage) {
  return chain(errorMessage)
    .split(".")
    .filter(sentence => startsWith(trim(sentence), "Alias must be"))
    .trim()
    .value()
}
